import styled from "styled-components";

export const VideoContainer = styled.div<{ $isShow: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme, $isShow }) =>
    $isShow
      ? theme.spacing["spacing-2"].value
      : theme.spacing["spacing-none"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-primary-subtle"].value};
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
`;

export const PreviewHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

export const PreviewBody = styled.div<{ height: number; $isOpen: boolean }>`
  max-height: ${({ height }) => height + "px"};
  overflow: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  transition: max-height 0.3s ease;
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}rem
    ${({ theme }) => theme.spacing["spacing-10"].value}rem;
`;
